import { render, staticRenderFns } from "./AvisoPrivacidad.vue?vue&type=template&id=aad4b9c2&"
import script from "./AvisoPrivacidad.vue?vue&type=script&lang=js&"
export * from "./AvisoPrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./AvisoPrivacidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports